//外协工资发放
import { $http, buildHeaders } from "./index";

//获取外协工资发放列表
export const salarypaymentoutsource_list = (params) => {
  return $http.get("/admin/SalaryPaymentOutsource/index", { params });
};

//获取外协工资发放详情
export const salarypaymentoutsource_detail = (id) => {
  return $http.get("/admin/SalaryPaymentOutsource/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取外协工资单工资表明细
export const salarypaymentoutsource_records = (params) => {
  return $http.get("/admin/SalaryPaymentOutsource/detail", {
    params,
  });
};

//标记失败
export const salarypaymentoutsource_setfailure = (data) => {
  return $http.post("/admin/SalaryPaymentOutsource/setFailure", data, {
    headers: buildHeaders(3),
  });
};

//标记已算税
export const salarypaymentoutsource_setDone = (data) => {
  return $http.post("/admin/SalaryPaymentOutsource/setDone", data, {
    headers: buildHeaders(3),
  });
};

//获取发薪单操作日志
export const salarypaymentoutsource_log = (params) => {
  return $http.get("/admin/SalaryPaymentOutsource/log", { params });
};

//上传薪酬发放电子回单文件
export const salarypaymentoutsource_log_upload = (data) => {
  return $http.post("/admin/SalaryPaymentOutsource/uploadSftpFile", data, {
    headers: buildHeaders(3),
  });
};

//下载发薪单电子回单
export const salarypaymentoutsource_log_donwload = (params) => {
  return $http.get("/admin/SalaryPaymentOutsource/downloadSftpFile", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//删除电子回单
export const salarypaymentoutsource_delsftpfile = (data) => {
  return $http.post("/admin/SalaryPaymentOutsource/delSftpFile", data, {
    headers: buildHeaders(3),
  });
};
